import { SettingConst } from '@faire/web-api--source/types';

/**
 * Integration Id for SunCo Chat widget
 */
export const HELP_CENTER_SUNCO_INTEGRATION_ID_230130 =
  'HELP_CENTER_SUNCO_INTEGRATION_ID_230130' as SettingConst<
    'HELP_CENTER_SUNCO_INTEGRATION_ID_230130',
    string,
    'HELP_CENTER' | 'RETAILER_IOS' | 'RETAILER_ANDROID'
  >;
